import {parse} from 'date-fns';

const parseDateString = (dateString: string) => parse(dateString, 'yyyy-LL-dd', new Date());

export default parseDateString;
